import React, { useState, useEffect } from 'react';
import styles from './CaptureNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import CaptureModal from './capture-modal/CaptureModal';
import { variableManagement } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';

const CaptureNode = ({ id, data, selected, ...props }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [label, setLabel] = useState(null);
  const [isError, setIsError] = useState(node?.is_Error || false);

  const { data: apiData, isFetching } = useFetch(
    ['variableManagement'],
    variableManagement.get,
    { enabled: true },
    { pageSize: 1000, pageNumber: 1 },
  );

  const isEntitiesMode =
    node?.capture?.isEntities === true ||
    node?.capture?.selectedTab === '1' ||
    node?.selectedTab === '1';

  useEffect(() => {
    if (!isEntitiesMode && apiData?.data?.items && node?.capture?.variableId) {
      const foundVariable = apiData.data.items.find(
        (val) => val.variableId === node.capture.variableId,
      );
      setLabel(foundVariable?.variableName || null);
    } else {
      setLabel(null);
    }
  }, [apiData, node?.capture?.variableId, isEntitiesMode]);

  useEffect(() => {
    if (node?.capture === undefined) {
      setIsError(node?.is_Error || true);
      return;
    }

    if (isEntitiesMode) {
      const list = node?.capture?.suggestedEntityQuestions || [];
      setIsError(list.length === 0);
    } else {
      setIsError(!node?.capture?.variableId || label === null);
    }
  }, [node?.capture, label, isEntitiesMode]);

  const typeOptions =
    apiData?.data?.items?.map((item) => ({
      value: item.variableId,
      label: item.variableName,
    })) || [];

  return (
    <>
      <NodeContainer
        name={node?.title ?? 'Capture Block'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type='target'
          position={Position.Left}
          className='custom-handle'
        />
        <div className={styles.cont}>
          {node?.capture == undefined ? (
            <div className={styles.details}>
              <SvgWithBranding type='node-capture' color='#787878' />
              <p className={styles.placeholder}>Select Entity to Capture</p>
            </div>
          ) : isEntitiesMode ? (
            <div className={`${styles.details} ${styles.entitiesDetails}`}>
              <SvgWithBranding type='node-capture' color='#787878' />
              <p className={styles.placeholder}>Capture Entities</p>
              {node?.capture?.suggestedEntityQuestions &&
                node?.capture?.suggestedEntityQuestions.map((item) => {
                  const label =
                    typeOptions.find((o) => o.value === item.variableId)
                      ?.label || item.variableId;
                  return <p className={styles.type}>{label}</p>;
                })}
            </div>
          ) : !node?.capture?.variableId ? (
            <div className={styles.details}>
              <SvgWithBranding type='node-capture' color='#787878' />
              <p className={styles.placeholder}>Select Entity to Capture</p>
            </div>
          ) : (
            <>
              <div className={styles.details}>
                <SvgWithBranding type='node-capture' color='#787878' />
                <p>Save Entire Reply to:</p>
              </div>
              {label && <p className={styles.type}>{label}</p>}
            </>
          )}
        </div>
        <Handle
          type='source'
          position={Position.Right}
          className='custom-handle'
        />
      </NodeContainer>

      <CaptureModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Capture'
        id={id}
        data={apiData}
        isFetching={isFetching}
        isError={isError}
      />
    </>
  );
};

export default CaptureNode;
